import { TaskType } from "@teamprevent/common/consultations/models";

import { CreateTaskModel } from "../model";

export interface AddBillingTaskFormModel {
    taskCode: string;
    notes: string;
    amount: number;
}

export const mapToCreateBillingTaskModel = (addTaskFormModel: AddBillingTaskFormModel, taskType: TaskType, ohCaseId: string): CreateTaskModel => ({
    taskType: taskType.type,
    description: taskType.description,
    taskCodeId: addTaskFormModel.taskCode,
    notes: addTaskFormModel.notes ? `Amount: ${addTaskFormModel.amount} | ${addTaskFormModel.notes}` : `Amount: ${addTaskFormModel.amount}`,
    caseId: ohCaseId,
    amount: Math.round(addTaskFormModel.amount * 100),
});
